
import React from "react";

const Intro = () => {
  return (
    <div className="intro wow animate__animated animate__fadeIn">
      <div className="intro-text">
        <div className="title-row">
          <span className="focusing">Focusing</span>
          <span className="focusing">on</span>
          <span className="focusing">what</span>
        </div>
        <div className="title-row">
          <span className="focusing">really</span>
          <span className="focusing">matters</span>
        </div>
      </div>
    </div>
  );
};

export default Intro;
